<template>
  <div id="data-manager">
    <div class="panel">
      <div class="panel-head">
        <h2>Data Manager</h2>
        <ul class="actions">
          <li>
            <a @click.prevent="showImportData = true" href="#" class="action">Import Data</a>
          </li>
        </ul>
      </div>

      <div class="panel-content">
        <div id="settings">
          <div class="row">
            <div class="col col-2x">
              <div class="form-control">
                <label for="client">Client</label>
                <select v-model="clientId" id="client">
                  <option
                    v-for="client in clients.filter(client=> client.status =='active')"
                    :key="client.id"
                    :value="client.id"
                  >{{ client.name }}</option>
                </select>
              </div>
            </div>
            <div class="col">
              <div class="form-control">
                <label for="start">Start Date</label>
                <datepicker
                  id="startDate"
                  :format="formatDate"
                  :value="startDate"
                  @input="setStartDate($event)"
                  required
                ></datepicker>
              </div>
            </div>
            <div class="col">
              <div class="form-control">
                <label for="end">End Date</label>
                <datepicker
                  id="startDate"
                  :format="formatDate"
                  :value="endDate"
                  @input="setEndDate($event)"
                  required
                ></datepicker>
              </div>
            </div>
          </div>
        </div>

        <div v-if="updated.length > 0" class="alert">
          <p>Changes have been made. Would you like to save these changes?</p>
          <button @click.prevent="saveChanges()" class="button button-red">Save Changes</button>
        </div>

        <loading v-if="loading"></loading>
        <div v-else id="data">
          <div class="row">
            <!-- Google -->
            <div class="col">
              <table>
                <thead>
                  <tr>
                    <th>Google</th>
                    <th>Spent</th>
                    <th>Conversions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="tracker in googleTrackers" :key="tracker.id">
                    <td>
                      <p>{{ tracker.date }}</p>
                    </td>
                    <td>
                      <input
                        v-model="tracker.spent"
                        @keydown="addToUpdated(tracker)"
                        type="text"
                      />
                    </td>
                    <td>
                      <input
                        v-model="tracker.conversions"
                        @keydown="addToUpdated(tracker)"
                        type="text"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>

              <form @submit.prevent="addEntry($event, 'google')" class="new-entry">
                <table>
                  <tr>
                    <td class="date-picker">
                      <datepicker name="date" :format="formatDate"></datepicker>
                    </td>
                    <td>
                      <input type="text" name="spent" placeholder="spend" />
                    </td>
                    <td>
                      <input type="text" name="conversions" placeholder="conversions" />
                    </td>
                  </tr>
                </table>
                <button class="button button-blue">Add Entry</button>
              </form>
            </div>

            <!-- Microsoft -->
            <div class="col">
              <table>
                <thead>
                  <tr>
                    <th>Microsoft</th>
                    <th>Spent</th>
                    <th>Conversions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="tracker in microsoftTrackers" :key="tracker.id">
                    <td>
                      <p>{{ tracker.date }}</p>
                    </td>
                    <td>
                      <input
                        v-model="tracker.spent"
                        @keydown="addToUpdated(tracker)"
                        type="text"
                      />
                    </td>
                    <td>
                      <input
                        v-model="tracker.conversions"
                        @keydown="addToUpdated(tracker)"
                        type="text"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>

              <form @submit.prevent="addEntry($event, 'microsoft')" class="new-entry">
                <table>
                  <tr>
                    <td class="date-picker">
                      <datepicker name="date" :format="formatDate"></datepicker>
                    </td>
                    <td>
                      <input type="text" name="spent" placeholder="spend" />
                    </td>
                    <td>
                      <input type="text" name="conversions" placeholder="conversions" />
                    </td>
                  </tr>
                </table>
                <button class="button button-blue">Add Entry</button>
              </form>
            </div>
          </div>

          <div class="row">
            <!-- Facebook -->
            <div class="col">
              <table>
                <thead>
                  <tr>
                    <th>Facebook</th>
                    <th>Spent</th>
                    <th>Conversions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="tracker in facebookTrackers" :key="tracker.id">
                    <td>
                      <p>{{ tracker.date }}</p>
                    </td>
                    <td>
                      <input
                        v-model="tracker.spent"
                        @keydown="addToUpdated(tracker)"
                        type="text"
                      />
                    </td>
                    <td>
                      <input
                        v-model="tracker.conversions"
                        @keydown="addToUpdated(tracker)"
                        type="text"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>

              <form @submit.prevent="addEntry($event, 'facebook')" class="new-entry">
                <table>
                  <tr>
                    <td class="date-picker">
                      <datepicker name="date" :format="formatDate"></datepicker>
                    </td>
                    <td>
                      <input type="text" name="spent" placeholder="spend" />
                    </td>
                    <td>
                      <input type="text" name="conversions" placeholder="conversions" />
                    </td>
                  </tr>
                </table>
                <button class="button button-blue">Add Entry</button>
              </form>
            </div>

            <!-- Calls -->
            <div class="col">
              <table>
                <thead>
                  <tr>
                    <th>Call Trackers</th>
                    <th>Calls</th>
                    <th>Conversions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="tracker in callTrackers" :key="tracker.id">
                    <td>
                      <p>{{ tracker.date }}</p>
                    </td>
                    <td>
                      <input
                        v-model="tracker.calls"
                        @keydown="addToUpdated(tracker)"
                        type="text"
                      />
                    </td>
                    <td>
                      <input
                        v-model="tracker.conversions"
                        @keydown="addToUpdated(tracker)"
                        type="text"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>

              <form @submit.prevent="addEntry($event, 'call')" class="new-entry">
                <table>
                  <tr>
                    <td class="date-picker">
                      <datepicker name="date" :format="formatDate"></datepicker>
                    </td>
                    <td>
                      <input type="text" name="calls" placeholder="calls" />
                    </td>
                    <td>
                      <input type="text" name="conversions" placeholder="conversions" />
                    </td>
                  </tr>
                </table>
                <button class="button button-blue">Add Entry</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <import-data :show="showImportData" @close="showImportData = false"></import-data>
  </div>
</template>

<script>
import ImportData from "@/components/lead-tracker/ImportData";
import Loading from "@/components/ui/Loading";
import Datepicker from "vuejs-datepicker";
import moment from "moment";

import { mapActions, mapGetters } from "vuex";

export default {
  name: "DataManager",
  components: {
    ImportData,
    Datepicker,
    Loading
  },
  data() {
    return {
      clientId: null,
      loading: false,
      clients: [],
      trackers: [],
      updated: [],
      showImportData: false,
      numberFormat: {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }
    };
  },
  created() {
    this.getClients();

    if (this.$route.query.clientId) {
      this.clientId = this.$route.query.clientId;
    }
  },
  mounted() {
    this.checkInput();
  },
  watch: {
    input: {
      handler(value) {
        this.checkInput();
      },
      deep: true
    },
    clientId: {
      handler(value) {
        this.checkInput();
      }
    }
  },
  computed: {
    ...mapGetters({
      startDate: "getStartDate",
      endDate: "getEndDate",
      listIds: "getListIds",
      clientIds: "getClientIds",
      management: "getManagement",
      input: "getInput"
    }),
    googleTrackers() {
      return this.trackers.filter(tracker => tracker.type == "google");
    },
    microsoftTrackers() {
      return this.trackers.filter(tracker => tracker.type == "microsoft");
    },
    facebookTrackers() {
      return this.trackers.filter(tracker => tracker.type == "facebook");
    },
    callTrackers() {
      return this.trackers.filter(tracker => tracker.type == "call");
    }
  },
  methods: {
    ...mapActions([
      "setStartDate",
      "setEndDate",
      "setManagement",
      "updateListIds",
      "updateClientIds",
      "addClientId",
      "selectClientId"
    ]),
    checkInput() {
      if (this.clientId && this.startDate && this.endDate) {
        this.getTrackers();
      }
    },
    async getClients() {
      let response = await this.$http.get("/clients");
      this.clients = response.data;
    },
    async getTrackers() {
      this.loading = true;
      let data = JSON.parse(JSON.stringify(this.input));
      data.clientId = this.clientId;
      let response = await this.$http.get("/lead-tracker", { params: data });
      this.trackers = response.data;
      this.loading = false;
    },
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    addToUpdated(tracker) {
      let i = this.updated.indexOf(tracker);
      if (i == -1) {
        this.updated.push(tracker);
      }
    },
    addEntry(e, channel) {
      let data = {};
      data.type = channel;
      for (let i = 0; i < 3; i++) {
        if (e.target.elements[i].value == "") {
          return false;
        }
        data[e.target.elements[i].name] = e.target.elements[i].value;
      }
      this.trackers.push(data);
      this.updated.push(data);
      e.target.reset();
    },
    async saveChanges() {
      this.updated.forEach(function(tracker) {
        if(typeof tracker.spent == 'string') {
          tracker.spent = tracker.spent.replace(',', '');
        }
        if(typeof tracker.conversions == 'string') {
          tracker.conversions = tracker.conversions.replace(',', '');
        }
      });
      let data = {
        trackers: this.updated,
        clientId: this.clientId
      };
      await this.$http.put("/lead-tracker", data);
      this.updated = [];
      this.getTrackers();
    }
  }
};
</script>

<style lang="scss">
#data-manager {
  #settings {
    background: lighten($light-gray, 3%);
    padding: 15px 30px;
    margin-bottom: 30px;

    .col {
      margin-bottom: 0;
    }

    button {
      margin: 0;
    }
  }

  .alert {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px;
    border-radius: 4px;
    background: lighten($red, 35%);
    font-weight: 600;
    margin-bottom: 30px;

    button {
      margin: 0;
    }
  }

  .new-entry {
    margin: 15px;

    button {
      margin: 10px 0;
    }
  }

  th,
  td {
    text-align: center;
    padding: 0;
    font-weight: 500;
  }

  th {
    padding: 10px 15px;
    background: $medium-blue;
    color: $white;
    font-weight: 600;
  }

  td {
    border: 0;
    border: 1px solid $light-gray;
    background: $light-gray;

    &:first-of-type {
      border-color: lighten($medium-gray, 5%);
    }

    &.date-picker {
      border: none;
      padding: 0 5px;
      background: $white;

      input {
        border: 1px solid lighten($medium-gray, 5%);
        border-radius: 5px;
      }
    }

    p {
      margin: 5px 15px;
    }

    input {
      border-radius: 0;
      border: 1px solid transparent;

      &:focus {
        border: 1px solid $green;
      }
    }
  }
}
</style>
